<script>
    import IconBack from "../icons/IconBack.svelte";

    export let onClick;
</script>

<button on:click|preventDefault={onClick} class="multistep-form-back">
    <IconBack />
</button>
